import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_TYPE_IGNORED_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDishTypeIgnoredDetailsArgs } from '../graphql/transformers'
import { UPDATE_DISH_TYPE_IGNORED_DETAILS } from '../redux/action-types'

const useUpdateDishTypeIgnoredDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isIgnoredDetailsLoading, ignoredDetailsError } = useSelector(
    store => store.dishTypes.dishType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DISH_TYPE_IGNORED_DETAILS_MUTATION,
        { id, data: transformToUpdateDishTypeIgnoredDetailsArgs(data) },
        dispatch,
        UPDATE_DISH_TYPE_IGNORED_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isIgnoredDetailsLoading, error: ignoredDetailsError },
  ]
}

export default useUpdateDishTypeIgnoredDetailsMutation
